const EMPTY_TOKEN_SCOPE = 'none';

function hashToken(token: string | null | undefined): string {
  if (!token) return EMPTY_TOKEN_SCOPE;

  let hash = 0;
  for (let index = 0; index < token.length; index += 1) {
    hash = (hash * 31 + token.charCodeAt(index)) >>> 0;
  }

  return hash.toString(36);
}

export function createAuthQueryScope(
  accessToken: string | null | undefined,
  switchAccessToken: string | null | undefined,
): string {
  return `access:${hashToken(accessToken)}|switch:${hashToken(
    switchAccessToken,
  )}`;
}
